<div class="zentra-admin-success-dialog">
  <h1 mat-dialog-title>Success!</h1>

  <div mat-dialog-content class="message">
    <h3>Trial Subscription has been created successfully.</h3>
    <div class="image-container">
      <img
        src="../../../../assets/weDraw-Images/undraw_completing_gsf8 (2).svg"
        alt="Checkmark woman figure"
      />
    </div>
  </div>
  <div mat-dialog-actions class="actions">
    <button
      color="primary"
      routerLink="/overtur-admin-subscriptions"
      mat-raised-button
      mat-dialog-close
    >
      Home
    </button>
  </div>
</div>
